<template>
	<div class="page">
		<h1>登录</h1>
		<div class="content-p">
			<img src="../../assets/login-fail.png" alt="" />
			<h2>登录失败</h2>
			<div class="info">请重新登录</div>
			<div class="space"></div>
			<button @click="goBack">返回登录</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: "LoginFail",
		methods: {
			goBack() {
				console.log(this.$route)
				//this.$router.back(-1)
				this.goto('/auth')
			}
		}
	};
</script>


<style lang="less" scope>
	.page {
		height: 100vh;
		width: 100vw;
		flex-direction: column;
		align-items: center;
		display: flex;
		padding: 0 16px;
		box-sizing: border-box;
	}

	h1 {
		border: none;
	}

	.content-p {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
		flex: 1 1;
		box-sizing: border-box;
		margin: 16px 0;
		background: #ffffff;
		border-radius: 10px;
		padding: 0 20px;
	}

	img {
		width: 105px;
		margin-top: 140px;
	}

	h2 {
		font-size: 16px;
		margin: 8px;
	}

	.info {
		font-size: 14px;
		color: #999999;
	}

	.space {
		flex: 1 1;
	}

	button {
		width: 100%;
		border: none;
		margin-bottom: 20px;
		height: 34px;
		line-height: 34px;
		border-radius: 17px;
		color: white;
		font-size: 16px;
		font-weight: 500;
		background: linear-gradient(to right, #e0ac77, #ba8859);
	}
</style>
